// tslint:disable
export var CardLoadProcessStatus;
(function (CardLoadProcessStatus) {
    // Pending
    CardLoadProcessStatus[CardLoadProcessStatus["Pending"] = 0] = "Pending";
    // Successful
    CardLoadProcessStatus[CardLoadProcessStatus["Successful"] = 1] = "Successful";
    // Failed
    CardLoadProcessStatus[CardLoadProcessStatus["Failed"] = 2] = "Failed";
    // Void
    CardLoadProcessStatus[CardLoadProcessStatus["Void"] = 3] = "Void";
})(CardLoadProcessStatus || (CardLoadProcessStatus = {}));
CardLoadProcessStatus['PENDING'] = 0;
CardLoadProcessStatus['SUCCESSFUL'] = 1;
CardLoadProcessStatus['FAILED'] = 2;
CardLoadProcessStatus['VOID'] = 3;
//# sourceMappingURL=CardLoadProcessStatus.js.map